import { uiStrings as ui } from '@satu/shared'
import { Suspense, ViewTransition } from 'react'
import { Outlet, useLocation } from 'react-router'
import { PitaPindahAlamat } from '@/app/shell/PitaPindahAlamat'
import { PenghapusanDialog } from '@/auth/guard'
import { KreditPengembang } from '@/components/primitives/KreditPengembang'
import { useUi } from '../../app/store/ui'
import { isTabLain, TabLainRoute } from './TabLainRoute'

/** Alt text for the mark on Masuk only (CONTENT.md section 19); elsewhere it is decorative. */
export const ALT_LAMBANG = 'Lambang Paroki Katedral Salib Suci Agats'

/**
 * The frame outside the shell for /masuk and its steps: paper edge to edge, one centred
 * card of 24 rem. The colour mark at 96 px sits in the layout, above the route crossfade,
 * so it is present the moment the splash releases (the FLIP settles onto it); its own
 * view-transition name lets it glide when a shorter or taller screen recentres the card
 * while the screens change beneath it with the shell's crossfade (old 120 ms out, new
 * 240 ms in with a 6 px rise). The wipe dialog can appear here too: a revoked device
 * learns it at login. Under the card column, the frame's last row holds the developer's
 * credit (release 23): it stays at the foot of the screen while the screens change, and
 * follows the card down when a tall screen outgrows a short phone.
 */
export function MasukLayout() {
  const lock = useUi((s) => s.lock)
  const { pathname } = useLocation()
  // The e-mail pages (forgotten password, the reset link, the e-mail change's confirmation)
  // need no database: a SATU tab open elsewhere does not keep someone from using them here.
  const tanpaBasisData = /^\/masuk\/(lupa-sandi|sandi-baru|konfirmasi-email)\/?$/.test(pathname)
  if (!tanpaBasisData && isTabLain(lock)) return <TabLainRoute state={lock} />
  const diMasuk = pathname.replace(/\/$/, '') === '/masuk'
  return (
    <>
      {/* Release 26, on the old address only: the move's sentence, or the moved device's link. */}
      <PitaPindahAlamat diLuarShell />
      <main
        id="isi"
        className="grid min-h-svh grid-rows-[1fr_auto] justify-items-center gap-10 bg-bg px-4 py-10"
      >
        {/* A stable minimum height keeps the centred card still while a screen arrives or
            grows (layout shift was 0.13 on /masuk). */}
        <div className="min-h-[32rem] w-full max-w-[24rem] space-y-6 self-center">
          <img
            src="/brand/logo-katedral-baru.svg"
            alt={diMasuk ? ALT_LAMBANG : ''}
            aria-hidden={diMasuk ? undefined : true}
            width={96}
            height={96}
            className="size-24 [view-transition-name:masuk-mark]"
            data-mark-target=""
          />
          {/* Release 24: the full name of SATU, once, under the mark. */}
          <p data-nama-lengkap="" className="-mt-3 text-body font-medium text-muted">
            {ui.umum.namaLengkap}
          </p>
          <ViewTransition default="rute">
            <div>
              <Suspense fallback={null}>
                <Outlet />
              </Suspense>
            </div>
          </ViewTransition>
        </div>
        <KreditPengembang teks={ui.umum.dikembangkanOleh} className="text-center" />
      </main>
      <PenghapusanDialog />
    </>
  )
}
